import type { IconName } from "./iconsMap";

export const PROFILE_AVATAR_ICON_NAMES = [
  "avatar_boy_04_variant_2",
  "avatar_boy_07_variant_3_alt",
  "avatar_boy_07_variant_3",
  "avatar_boy_10_variant_4",
  "avatar_girl_06_variant_2",
  "avatar_girl_08_variant_3",
  "avatar_girl_13_variant_6",
  "avatar_girl_14_variant_7",
  "avatar_secondary_01",
  "avatar_secondary_02",
  "avatar_secondary_03",
  "avatar_secondary_04",
] as const;

const PROFILE_AVATAR_KEY_SET = new Set<string>(PROFILE_AVATAR_ICON_NAMES);

export const DEFAULT_UNKNOWN_PROFILE_AVATAR_ICON: IconName =
  "avatar_boy_04_variant_2";

function normalizePhotoCandidates(raw: string): string[] {
  const t = raw.trim();
  if (!t) return [];
  const lower = t.toLowerCase();
  const withAvatarPrefix = t.replace(/^Avatar_/i, "avatar_");
  const withAvatarPrefixLower = withAvatarPrefix.toLowerCase();
  return [...new Set([t, lower, withAvatarPrefix, withAvatarPrefixLower])];
}

function findMatchingProfileAvatarKey(raw: string): string | null {
  for (const c of normalizePhotoCandidates(raw)) {
    if (PROFILE_AVATAR_KEY_SET.has(c)) return c;
  }
  return null;
}

export function userAccountPhotoShouldUseInitials(
  photo: string | null | undefined,
): boolean {
  if (photo == null) return true;
  const t = String(photo).trim();
  if (t === "") return true;
  return t.toLowerCase() === "noprofile";
}

export function resolveUserAccountPhotoToIconName(
  photo: string | null | undefined,
): IconName {
  const raw = String(photo ?? "").trim();
  const match = findMatchingProfileAvatarKey(raw);
  if (match) return match as IconName;
  return DEFAULT_UNKNOWN_PROFILE_AVATAR_ICON;
}

export function isKnownProfileAvatarIconName(name: string): boolean {
  return PROFILE_AVATAR_KEY_SET.has(name.trim());
}

export function resolveHeaderProfileOrIconName(rightIcon: string): IconName {
  const raw = rightIcon.trim();
  if (raw === "") return DEFAULT_UNKNOWN_PROFILE_AVATAR_ICON;
  const match = findMatchingProfileAvatarKey(raw);
  if (match) return match as IconName;
  if (/^avatar_/i.test(raw)) return DEFAULT_UNKNOWN_PROFILE_AVATAR_ICON;
  return raw as IconName;
}
